window.addEventListener('DOMContentLoaded', () => {
  if (document.querySelectorAll('.dsgvo-flockler').length) {
    import('./_dsgvo-flockler').then((module) => {
      module.Init();
    });
  }
});

export default {}
